export default __webpack_public_path__ + "images/referrals-onboarding-step-2.dedabe93b072fc3ef46c6b77a0622935.png";